import Type from '@/models/deals/Type';
<template>
  <div>
    <el-dialog
      :title="InactivationDialog.title"
      :visible.sync="InactivationDialog.isVisible"
      :close-on-click-modal="false"
      @close="oncloseInactivationForm"
    >
      <el-form :model="InactivationForm" :rules="rules" ref="inactivationForm">
        <!--
        <el-form-item label="Servicios a inactivar" prop="servicesSelected">
          <el-select
            v-model="InactivationForm.servicesSelected"
            filterable
            placeholder="Servicios"
            :disabled="InactivationDialog.DisabblingButtons"
          >
            <el-option
              v-for="item in ServicesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        -->
        <el-form-item
          label="Mensaje a mostrar en las terminales"
          prop="terminalsMessage"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 5 }"
            placeholder="Escriba su mensaje aqui"
            v-model="InactivationForm.terminalsMessage"
            :disabled="InactivationDialog.DisabblingButtons"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="Razon para inactivar servicio"
          prop="inactivateReason"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 5 }"
            placeholder="Escriba la razon aqui"
            v-model="InactivationForm.inactivateReason"
            :disabled="InactivationDialog.DisabblingButtons"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="oncloseInactivationForm"
          :disabled="InactivationDialog.DisabblingButtons"
          >Cancelar</el-button
        >
        <el-button
          type="primary"
          @click="InactivateService('inactivationForm')"
          :disabled="InactivationDialog.DisabblingButtons"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
//import from ""
export default {
  name: "AuthorizerInactivationForm",
  props: {
    makeItVisible: {
      Type: Boolean,
      default: false
    },
    ServiceRowData: {
      Type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      actualRowData: {},
      InactivationDialog: {
        title: "Servicio a inactivar: ",
        isVisible: false,
        DisabblingButtons: false
      },
      InactivationForm: {
        servicesSelected: "", //[],
        terminalsMessage: "",
        inactivateReason: ""
      },
      rules: {
        servicesSelected: [
          {
            required: true,
            message: "Favor seleccione el servicio a inactivar",
            trigger: "change"
          }
        ],
        terminalsMessage: [
          {
            required: true,
            message: "Favor insertar el mensaje a mostrarse en la terminal",
            trigger: "blur"
          },
          {
            min: 10,
            max: 100,
            message:
              "Se requiere un minimo de 10 caracteres y un maxiimo de 100 caracteres",
            trigger: "blur"
          }
        ],
        inactivateReason: [
          {
            required: true,
            message:
              "Favor insertar el motivo por el cual se va a inactivar el servicio",
            trigger: "blur"
          },
          {
            min: 10,
            max: 100,
            message:
              "Se requiere un minimo de 10 caracteres y un maxiimo de 100 caracteres",
            trigger: "blur"
          }
        ]
      },
      ServicesOptions: [
        {
          value: "MAGYPAGO",
          label: "MAGYPAGO"
        },
        {
          value: "NCFMOVIL",
          label: "NCFMOVIL"
        },
        {
          value: "FIDELIZACION",
          label: "FIDELIZACION"
        },
        {
          value: "TICKET",
          label: "TICKET"
        }
      ]
    };
  },
  methods: {
    oncloseInactivationForm(form) {
      this.$emit("oncloseInactivationForm", form);
      this.$refs.inactivationForm.resetFields();
      this.InactivationDialog.DisabblingButtons = false;
    },
    InactivateService() {
      //console.log("inactivationFormName: ", inactivationFormName);
      this.$refs.inactivationForm.validate((valid) => {
        //console.log("Validacion: ", valid);
        if (valid) {
          this.$confirm(
            `Esta a punto de inactivar el servicio ${this.actualRowData.ServiceName},
                        \n el mismo quedara desactivado hasta que se vuelva a reactivar.\n Desea continuar?`,
            "Cuidado",
            {
              confirmButtonText: "Continuar",
              cancelButtonText: "Cancelar",
              type: "warning"
            }
          )
            .then(() => {
              this.InactivationDialog.DisabblingButtons = true;
              this.actualRowData.Actived = true;
              this.actualRowData.InactiveAt = new Date();
              (this.actualRowData.MessageTerminal =
                this.InactivationForm.terminalsMessage),
                (this.actualRowData.Reason =
                  this.InactivationForm.inactivateReason);
              /*
              const params = {
                ServiceName: this.actualRowData.ServiceName,
                CreateAt: this.ServiceRowData.CreateAt,
                Actived: false,
                InactiveAt: new Date(),
                MessageTerminal: this.InactivationForm.terminalsMessage,
                Reason: this.InactivationForm.inactivateReason
              };
              */
              try {
                this.$http
                  .put(
                    "/api/tennos/ReactivateAuthorizerService",
                    this.actualRowData
                  )
                  .then(() => {
                    //console.log("resp del put: ", resp);
                    this.$message({
                      type: "success",
                      message: `Servicio  ${this.actualRowData.ServiceName} inactivado con exito`
                    });
                    this.InactivationDialog.isVisible = false;
                  })
                  .catch((err) => {
                    console.error("error al inactivar servicio: ", err);
                    //console.log("error data: ", err);
                    this.InactivationDialog.DisabblingButtons = false;
                  })
                  .finally(() => {
                    this.$emit("rechargingServices");
                  });
              } catch (e) {
                //console.log("error data try catch:  ", e);
              }
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: `ha cancelado la inactivacion del servicio  ${this.actualRowData.ServiceName}`
              });
            });

          //console.log("Fue validado con exito");
          //console.log("InactivateService form: ", this.InactivationForm);
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    makeItVisible(val) {
      //console.log("Watchingmakeitvisible: ", val);
      this.InactivationDialog.isVisible = val;
    },
    ServiceRowData(val) {
      //console.log("actualRowData: ", val);
      this.actualRowData = val;
    }
  }
};
</script>

<style></style>
